import React from 'react'
import { useForm } from 'react-hook-form'
import toast from 'react-hot-toast'
import Modal from '../../../components/common/Modal'
import { api } from '../../../configs/api'
import { useBusiness } from '../../../context/BusinessContext'
import { BusinessType } from './BusinessDetail'

const BusinessDelete = ({
    open,
    handleClose,
    data
}: {
    open: boolean
    handleClose: () => void
    data: BusinessType | null
}) => {
    const { business, setBusiness, currentTab, currentStep, openDetail, loadBusiness } = useBusiness()
    const form = useForm({ mode: 'onChange' })
    const formRef = React.useRef<HTMLFormElement>(null)

    const handleDelete = async () => {
        const id = data?.id
        if (!id) {
            toast.error('Negócio não encontrado!')
            return
        }

        try {
            const response = await fetch(`${api}business/deleteBusiness`, {
                method: 'POST',
                body: JSON.stringify({ businessID: id })
            })

            const result = await response.json()
            if (!result.success) {
                toast.error(result.message || 'Erro ao excluir o negócio!')
                return
            }

            loadBusiness()
            toast.success('Negócio excluído com sucesso!')
        } catch (error) {
            console.log(error)
        } finally {
            handleClose()
        }
    }

    if (!open || !data) return null

    return (
        <Modal
            open={open}
            handleClose={handleClose}
            title='Excluir Negócio'
            maxWidth='max-w-xl'
            handleDelete={() => formRef.current?.requestSubmit()}
            canDelete
        >
            <form ref={formRef} onSubmit={form.handleSubmit(handleDelete)}>
                <div className='text-gray-800 dark:text-white/90 text-sm'>
                    <p>
                        Tem certeza que deseja exluir o negócio{' '}
                        <strong className='text-error-400'>
                            {data.title} #{data.id}
                        </strong>{' '}
                        ? Esta ação é irreversível.
                    </p>
                </div>
            </form>
        </Modal>
    )
}

export default BusinessDelete
